import { createMap } from "./createMap";
import { doUrlSummaryCheck } from "./general/initializeSummaries";
import { importConditions } from "./util/importConditions";
import { InitializeProxy } from "./createMap";
import * as css from "./css/BrandNewMaps.css"; 

if (!isWebGL2Supported())
{
    window.alert("Your browser does not support WebGL 2. This may cause issues while using our maps. Please consider updating your browser / hardware.")
}

let MapConfig = window.MapConfig;
let conditionalMapOptions = await importConditions(MapConfig); 
conditionalMapOptions.type = "public"; 
window.conditionalMapOptions = conditionalMapOptions;
(async ()=> {
  
    InitializeProxy();
    let summaryActive = await doUrlSummaryCheck(conditionalMapOptions);
    if (summaryActive) {
      let summaryModal = document.getElementById("summaryModal");
      const closeListener = () => {
        createMap(conditionalMapOptions);
        summaryModal.removeEventListener("calciteModalBeforeClose", closeListener); 
      };
      
      summaryModal.addEventListener("calciteModalBeforeClose", closeListener);
    } 
    else {
      createMap(conditionalMapOptions);
    }

    function refreshAntiforgeryToken() {
      fetch('/proxy/GetAntiforgeryToken')
          .then(response => response.json())
          .then(data => {
              document.querySelector('input[name="__RequestVerificationToken"]').value = data.token;
              
          })
          .catch(error => console.error('Error refreshing token:', error));
  }

    setInterval(refreshAntiforgeryToken, 10 * 60 * 1000); 

})();



function isWebGL2Supported() {
    try {
      const canvas = document.createElement('canvas');
      return !!(window.WebGL2RenderingContext && canvas.getContext('webgl2'));
    } catch (e) {
      return false;
    }
  }
  